import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import QrMenu from './QrMenu.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QrMenu />
  </React.StrictMode>
);